import React from 'react';
import Modal from 'react-bootstrap/Modal';
import JSONGenerator from '../../../services/api/JSONGenerator'
import { postApi } from "../../../services/api/requestApi";

export default class UploadGeoJson extends React.Component {

    constructor (props) {
        super (props);
        this.state = {
            alias: '',
            aoi: props.aoi,
            geoJsonFile: null,
            geoJsonSet: false,
            geoJson: null,
            showModal: props.showModal,
            setShowModal: props.setShowModal,
            reload: props.reload
        };
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleClose = () => {
        this.state.setShowModal('UploadGeoJson', false);
        this.setState({
            alias: '',
            geoJsonFile: null,
            layers: null,
            geoJsonSet: false,
            geoJson: null,
            name:''
        })
    }

    handleFileChange (e, file) {
        this.setState({
            [file]: e.target.files[0],
            loaded: 0
        })
        let fileName = e.target.files[0].name;
        let reader = new FileReader();
        reader.onload = function(e) {
            console.log(e.target.result);
            this.setState({geoJson: e.target.result});
            this.setState({geoJsonSet: true});
            this.setState({name: fileName});
        }.bind(this)
        reader.readAsText(e.target.files[0]);
    }

    handleSubmit = async() => {
        if (this.state.geoJson !== null) {
                
            let url = '/admin/aois/geojson';
            let body = {
                aoi: this.state.aoi.aoi_name,
                json: this.state.geoJson,
                name: this.state.name,
            }
            let response = await postApi(url, body);
            console.log(response);
            if (response !== false) {
                this.handleClose();
                this.state.reload();
            }

        }
        else {
            alert("Bitte füllen Sie alle Felder aus!");
        }
    }

    rendergeoJson () {
        let result = [];
        for (let directory in this.state.geoJson) {
            let subparts = [];
            let specialLayers = [];
            for (let subpart in this.state.geoJson[directory].Subparts) {
                subparts.push(subpart);
            }
            for (let specialLayer in this.state.geoJson[directory].SpecialLayers) {
                specialLayers.push(specialLayer);
            }
            result.push(
                <tr>
                    <td>
                        {this.state.geoJson[directory].ClearName}
                    </td>
                    <td>
                        {subparts.join(', ')}
                    </td>
                    <td>
                        {specialLayers.join(', ')}
                    </td>
                </tr>
            );
        }

        return result;

    }

    polygonUpload () {
        return (
            <>
                <Modal animation={false} show={this.state.showModal} onHide={this.handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Upload Polygon File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <input type="file" onChange={(e) => this.handleFileChange(e, 'geoJsonFile')}/>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex">
                            <button className="btn btn-light mr-3" type="button" onClick={this.handleSubmit} >Upload</button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    render () {
        return this.polygonUpload();
    }
}